import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Homestays",
  "Boutique Hotels",
  "Resorts",
  "Restaurants",
  "Cafes",
  "Bars & Lounges",
];

export const EditorialMarquee = () => {
  return (
    <section className="py-10 bg-paper-muted border-y border-black/5" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-medium text-3xl md:text-5xl text-ink/80 tracking-tight px-8">
              {item}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-brand mx-2" aria-hidden="true" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
